<template>
	<div id="faqs-page" data-aos="fade">
		<!-- Hero -->
		<section class="top-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<p class="hero-eyebrow">FAQs</p>
						<h1 class="hero-title">Preguntas frecuentes</h1>
						<p class="hero-lead">
							Encuentra respuestas a las preguntas más comunes sobre unlawk
						</p>
					</div>
				</div>
			</div>
		</section>

		<!-- FAQs -->
		<section class="faqs-section">
			<div class="container">
				<div class="row">
					<div class="col-12 col-lg-10 col-xl-8 mx-auto">
						<div
							v-for="faq in faqs"
							:key="faq.id"
							class="faq-item"
						>
							<button
								type="button"
								class="faq-toggle"
								:aria-expanded="openFaq === faq.id"
								@click="toggleFaq(faq.id)"
							>
								<h3 class="faq-question">{{ faq.question }}</h3>
								<i
									class="faq-chevron flex-shrink-0"
									:class="openFaq === faq.id
										? 'fa-regular fa-chevron-up text-primary'
										: 'fa-regular fa-chevron-down'"
								></i>
							</button>

							<b-collapse :visible="openFaq === faq.id">
								<div class="faq-answer">
									<p class="mb-0">{{ faq.answer }}</p>
								</div>
							</b-collapse>
						</div>

						<div class="cta-box text-center">
							<h2 class="cta-title">¿No encontraste lo que buscabas?</h2>
							<p class="cta-text">
								Nuestro equipo está listo para ayudarte con cualquier duda adicional
							</p>
							<b-button
								to="/contacto"
								variant="danger"
								size="lg"
								class="btn-contact"
							>
								<i class="fa-regular fa-envelope mr-2"></i>
								Contáctanos
							</b-button>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
export default {
	data() {
		return {
			openFaq: null,
			faqs: [
				{
					id: 1,
					question: '¿Qué es unlawk?',
					answer:
						'unlawk es una plataforma digital que conecta a personas y empresas con abogados especializados de manera rápida y eficiente. Utilizamos inteligencia artificial para ayudarte a encontrar el profesional legal ideal para tu caso.',
				},
				{
					id: 2,
					question: '¿Cómo funciona el proceso de búsqueda?',
					answer:
						'Nuestro buscador potenciado por IA analiza tu consulta y te presenta los abogados más adecuados según tu necesidad legal. Puedes filtrar por especialidad, ubicación, y tipo de profesional (particular o firma). Una vez que encuentres al abogado ideal, puedes contactarlo directamente a través de la plataforma.',
				},
				{
					id: 3,
					question: '¿Cuánto cuesta usar unlawk?',
					answer:
						'unlawk ofrece diferentes planes de suscripción: mensual, semestral y anual. Los usuarios pueden buscar y contactar abogados de forma gratuita, pero los planes premium ofrecen beneficios adicionales como consultas prioritarias y descuentos en servicios legales. Consulta nuestra página de Pricing para más detalles.',
				},
				{
					id: 4,
					question: '¿Cómo puedo afiliarme como abogado?',
					answer:
						'Si eres abogado o representas una firma legal, puedes unirte a unlawk completando el formulario de afiliación en nuestra página. El proceso incluye verificación de credenciales y aprobación de tu perfil. Una vez aprobado, podrás recibir consultas de clientes potenciales.',
				},
				{
					id: 5,
					question: '¿Los abogados están verificados?',
					answer:
						'Sí, todos los abogados y firmas en unlawk pasan por un proceso de verificación que incluye validación de cédula profesional, experiencia y referencias. Esto garantiza que solo profesionales calificados formen parte de nuestra red.',
				},
				{
					id: 6,
					question: '¿Puedo cancelar mi suscripción en cualquier momento?',
					answer:
						'Sí, puedes cancelar tu suscripción en cualquier momento desde tu panel de usuario. Si cancelas, seguirás teniendo acceso a los beneficios hasta el final del período de facturación actual.',
				},
				{
					id: 7,
					question: '¿Qué especialidades legales están disponibles?',
					answer:
						'unlawk cuenta con abogados especializados en diversas áreas del derecho, incluyendo: derecho civil, penal, laboral, mercantil, familiar, fiscal, administrativo, propiedad intelectual, y más. Puedes filtrar por especialidad en nuestro directorio.',
				},
				{
					id: 8,
					question: '¿Cómo se manejan los pagos?',
					answer:
						'Los pagos de suscripción a unlawk se procesan de forma segura a través de nuestra plataforma. Los honorarios de los abogados se negocian directamente entre el cliente y el profesional legal, unlawk no interviene en esas transacciones.',
				},
				{
					id: 9,
					question: '¿Ofrecen consultas gratuitas?',
					answer:
						'Algunos abogados en nuestra plataforma ofrecen consultas iniciales gratuitas. Esta información está disponible en el perfil de cada profesional. Te recomendamos revisar los detalles antes de contactar.',
				},
				{
					id: 10,
					question: '¿Qué hago si tengo un problema con un abogado?',
					answer:
						'Si tienes algún inconveniente con un abogado de nuestra red, puedes reportarlo a través de nuestra sección de Contacto seleccionando la opción \'Queja\'. Nuestro equipo revisará el caso y tomará las medidas necesarias.',
				},
			],
		}
	},

	methods: {
		toggleFaq(id) {
			this.openFaq = this.openFaq === id ? null : id
		},
	},
}
</script>
